<template>
  <div id="app" ref="mainApp">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>



// WEBPACK FOOTER //
// src/App.vue